import * as types from './action-types'

const initialState = {
  isLoading: true,
  isAuthenticated: false,
  isAuthenticating: false,
  error: null
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.LOADED:
      return { ...state, isLoading: false }

    case types.AUTHENTICATION_REQUEST:
      return { ...state, isAuthenticating: true, error: null }

    case types.AUTHENTICATION_SUCCESS:
      return { ...state, isAuthenticated: true, isAuthenticating: false }

    case types.AUTHENTICATION_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        isAuthenticating: false,
        error: payload.error
      }

    case types.LOGOUT:
      return {
        ...initialState,
        isLoading: false
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/user/reducer.js